module.exports = __webpack_public_path__ + "img/hk_qrcode.9504b584.png";